import { CREATED_BY_QUERY } from "@app/shared/users/users/queries/created-by.query";
import { FUEL_TYPE_DROPDOWN_QUERY } from "@app/shared/fleet/fuel-type/queries/fuel-type-dropdown.query";
import { GROUP_DROPDOWN_QUERY } from "@app/shared/fleet/group/queries/group-dropdown.query";
import { ENTITY_ACTION_PERMISSIONS_QUERY } from "@app/shared-core/queries/entity-action-permissions.query";
import { PHOTO_TYPE_STEP_CONFIG_QUERY } from "./photo-type-step.query";

/** GraphQL selection for the photo type form. */
export const PHOTO_TYPE_FORM_QUERY = `
  id
  entityId
  name
  description
  applicability {
    fuelTypes { ${FUEL_TYPE_DROPDOWN_QUERY} }
    groups { ${GROUP_DROPDOWN_QUERY} }
  }
  steps {
    CONTRACT_START { ${PHOTO_TYPE_STEP_CONFIG_QUERY} }
    INTERNAL_MULTI_VEHICLE_TRANSFER_CHECK_OUT { ${PHOTO_TYPE_STEP_CONFIG_QUERY} }
    INTERNAL_MULTI_VEHICLE_TRANSFER_CHECK_IN { ${PHOTO_TYPE_STEP_CONFIG_QUERY} }
    REVENUE_CHECK_OUT { ${PHOTO_TYPE_STEP_CONFIG_QUERY} }
    REVENUE_CHECK_IN { ${PHOTO_TYPE_STEP_CONFIG_QUERY} }
    NON_REVENUE_CHECK_OUT { ${PHOTO_TYPE_STEP_CONFIG_QUERY} }
    NON_REVENUE_CHECK_IN { ${PHOTO_TYPE_STEP_CONFIG_QUERY} }
  }
  order
  enabled
  createdAt
  updatedAt
  createdBy { ${CREATED_BY_QUERY} }
  ${ENTITY_ACTION_PERMISSIONS_QUERY}
`;
